import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
function MyNavbar() {
  return (
    <Navbar
      variant="dark"
      sticky="top"
      expand="md"
      style={{ backgroundColor: "rgb(26, 70, 101)" }}
    >
      <Container className="">
        <Link
          to="/"
          className="nav-link text-white"
          style={{ fontFamily: "Oxygen" }}
        >
          TROUBLE FIXER
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          style={{ justifyContent: "end" }}
        >
          <Nav>
            <Link to="/" className="nav-link">
              Home
            </Link>
            <Link to="/services" className="nav-link">
              Services
            </Link>
            {/* <Link to="/career" className="nav-link">
              Career
            </Link> */}
            <Link to="/contact" className="nav-link">
              Contact Us
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MyNavbar;
